import {
  CLEAR_EDIT_DEPOSIT,
  GET_EDIT_DEPOSIT_REQUEST,
  CREATE_EDIT_DEPOSIT_REQUEST,
  UPDATE_EDIT_DEPOSIT_REQUEST,
  EDIT_DEPOSIT_TSUNAMI_REQUEST,
  EDIT_DEPOSIT_REFERENCE_REQUEST,
  EDIT_DEPOSIT_REFERENCE_SEARCH_REQUEST,
  EDIT_DEPOSIT_COUNTRY_REQUEST,
  EDIT_DEPOSIT_TSUNAMI_SORT,
  EDIT_DEPOSIT_TSUNAMI_SEARCH_REQUEST,
  EDIT_DEPOSIT_REFERENCE_SORT,
  EDIT_DEPOSIT_OPEN_CONFIRMATION,
  EDIT_DEPOSIT_CANCEL_CONFIRMATION,
  EDIT_DEPOSIT_LOCATION_NAME_REQUEST,
  EDIT_DEPOSIT_PUBLICATIONS_REQUEST,
  EDIT_DEPOSIT_GEOLOGIC_AGE_REQUEST,
  EDIT_DEPOSIT_BODY_OF_WATER_REQUEST,
  EDIT_DEPOSIT_EVENT_REQUEST,
  EDIT_DEPOSIT_TSUNAMI_TOGGLE_COLUMN,
  EDIT_DEPOSIT_REFERENCE_TOGGLE_COLUMN,
} from './depositEditReducer';

export const getDeposit = ({ id }) => ({ type: GET_EDIT_DEPOSIT_REQUEST, id });
export const clearDeposit = () => ({ type: CLEAR_EDIT_DEPOSIT });
export const createDeposit = ({
  data, formModel, location, goBack,
}) => ({
  type: CREATE_EDIT_DEPOSIT_REQUEST, data, formModel, location, goBack,
});
export const updateDeposit = ({
  data, id, formModel, location, goBack,
}) => ({
  type: UPDATE_EDIT_DEPOSIT_REQUEST, data, id, formModel, location, goBack,
});
export const searchTsunamis = ({ queryParameters }) => ({
  type: EDIT_DEPOSIT_TSUNAMI_SEARCH_REQUEST,
  queryParameters,
});
export const getTsunamis = ({ id }) => ({ type: EDIT_DEPOSIT_TSUNAMI_REQUEST, id });
export const searchReferences = ({ queryParameters }) => ({
  type: EDIT_DEPOSIT_REFERENCE_SEARCH_REQUEST,
  queryParameters,
});

export const getReference = ({ id }) => ({ type: EDIT_DEPOSIT_REFERENCE_REQUEST, id });
export const getGeologicalAge = () => ({ type: EDIT_DEPOSIT_GEOLOGIC_AGE_REQUEST });
export const getCountries = () => ({ type: EDIT_DEPOSIT_COUNTRY_REQUEST });
export const getBodiesOfWater = () => ({ type: EDIT_DEPOSIT_BODY_OF_WATER_REQUEST });
export const getEvents = () => ({ type: EDIT_DEPOSIT_EVENT_REQUEST });
export const getPublications = () => ({ type: EDIT_DEPOSIT_PUBLICATIONS_REQUEST });
export const getLocationNames = () => ({ type: EDIT_DEPOSIT_LOCATION_NAME_REQUEST });
export const sortTsunamis = sort => ({ type: EDIT_DEPOSIT_TSUNAMI_SORT, sort });
export const sortReferences = sort => ({ type: EDIT_DEPOSIT_REFERENCE_SORT, sort });

export const openEditConfirmation = ({ formData }) => ({ type: EDIT_DEPOSIT_OPEN_CONFIRMATION, formData });
export const cancelEditConfirmation = () => ({ type: EDIT_DEPOSIT_CANCEL_CONFIRMATION });

export const toggleTsunamiColumns = visibleColumns => ({ type: EDIT_DEPOSIT_TSUNAMI_TOGGLE_COLUMN, visibleColumns });
export const toggleReferenceColumns = visibleColumns => ({ type: EDIT_DEPOSIT_REFERENCE_TOGGLE_COLUMN, visibleColumns });
